// extracted by mini-css-extract-plugin
export default {"customWidth":"about_customWidth__-FUpP","featureCard":"about_featureCard__8Goiq","cardText":"about_cardText__XJOd8"};